import { render, staticRenderFns } from "./PcViewIcon.vue?vue&type=template&id=787e9a5d&scoped=true"
import script from "./PcViewIcon.vue?vue&type=script&lang=js"
export * from "./PcViewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e9a5d",
  null
  
)

export default component.exports